import { saveDeactivatePartnerActions } from "./action";

const initialState = {
  DeactivateData: null,
};

const saveDeactivePartnerReducer = (state = initialState, action) => {
  switch (action.type) {
    case saveDeactivatePartnerActions.SAVE_DEACTIVE_PARTNER_DETAILS_SUCCESS:
      return {
        ...state,
        // accountNoVerify: action.payload.data,
      };
    case saveDeactivatePartnerActions.SAVE_DEACTIVE_PARTNER_DETAILS_ERROR:
      return {
        ...state,
        DeactivateData: [],
      };

    default:
      return state;
  }
};

export default saveDeactivePartnerReducer;
